var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageBreadcrumbs',{attrs:{"items":[
    ['Minhas Tarefas','/tasks'],
    ['Padrões','/tasks/patterns'],
    ['Nova Tarefa Padrão','/tasks/pattern/new'] ]}}),_c('TaskForm',{ref:"taskForm",attrs:{"loading":_vm.loading,"createInitialFilter":false},on:{"finalize":_vm.createTask},model:{value:(_vm.task),callback:function ($$v) {_vm.task=$$v},expression:"task"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }